import { AccountTransactionsTable } from './AccountTransactionsTable';

export const AccountTransactions = () => {
  return <AccountTransactionsTable />;
};
